import React from 'react'

export default function DebitCardIcon({
  color = '#676767',
}: {
  color?: string
}) {
  return (
    <svg
      width='26'
      height='26'
      viewBox='0 0 26 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3 9.50488H23'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7 17.5049H9'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.5 17.5049H15.5'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.55 4.50488C22.11 4.50488 23 5.38488 23 8.89488V17.1049C23 20.6149 22.11 21.4949 18.56 21.4949H7.44C3.89 21.5049 3 20.6249 3 17.1149V8.89488C3 5.38488 3.89 4.50488 7.44 4.50488H18.55Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        opacity='0.01'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M25 1V25H1V1H25Z'
        stroke={color}
        strokeWidth='2'
      />
    </svg>
  )
}
